document.addEventListener('DOMContentLoaded', function() {
    // Function to handle checkbox change for addon products
    function handleAddonCheckbox(addonCheckboxId, inputName) {
        const addonCheckbox = document.getElementById(addonCheckboxId);
        const productForm = document.querySelector('form[action="/cart/add"]');
        
        if (addonCheckbox && productForm) {
            addonCheckbox.addEventListener('change', function() {
                const addonProductId = addonCheckbox.getAttribute('data-id');
                let propertyName = addonCheckbox.getAttribute('name');   
                if (addonCheckbox.checked) {
                    productForm.querySelector(`#${propertyName}`).value = true;
                } else {
                    productForm.querySelector(`#${propertyName}`).value = false;
                }
            });
        }
    }

    // Initialize for the first addon product
    handleAddonCheckbox('addon-product-checkbox-1', 'addon_product_1');

    // Initialize for the second addon product
    handleAddonCheckbox('addon-product-checkbox-2', 'addon_product_2');
});

// Function to add the addon product to the cart
function addGiftProduct(main_prod_item_id, addon_variant_id) {
    console.log("Adding addon product:", addon_variant_id);
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            id: addon_variant_id,
            quantity: 1,
            properties: {
                "_main-product-ref": main_prod_item_id,
            }
        }),
    })
    .then(response => response.json())
    .then(data => {
        location.reload();
    })
    .catch((error) => {
        console.error('Error adding addon product:', error);
    });
}

// Function to remove the addon product from the cart
function removeAddonProductFromCart(addonProductId) {
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            const addonItem = cart.items.find(item => item.id === parseInt(addonProductId));
            if (addonItem) {
                fetch('/cart/change.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        id: addonItem.key,
                        quantity: 0,
                    }),
                })
                .catch(error => console.error('Error removing addon product:', error));
            }
        });
}
